import type { RefObject } from 'react';
import React from 'react'

const ScrollContext = React.createContext<RefObject<HTMLElement | null>>({
  current: null,
})

export default ScrollContext
